import { useState } from "react";
import { rankings } from "@/mocks/homeData";

const tabs = ["本周热榜", "本月热榜", "总榜"];

export default function RankingBoard() {
  const [activeTab, setActiveTab] = useState(0);

  const trendIcon = (trend: string) => {
    if (trend === "up") return <i className="ri-arrow-up-line text-primary-600" />;
    if (trend === "down") return <i className="ri-arrow-down-line text-secondary-500" />;
    return <i className="ri-subtract-line text-foreground-400" />;
  };

  return (
    <section id="ranking" className="px-4 md:px-8 py-10 border-t border-background-200/60">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <p className="text-xs tracking-[0.3em] text-primary-600 font-label mb-2">RANKING</p>
          <h2 className="font-heading text-xl md:text-3xl font-black text-foreground-950">合集热度榜单</h2>
        </div>
        <div className="flex items-center gap-2 px-1 py-1 rounded-full bg-background-100 border border-background-200">
          {tabs.map((tab, idx) => (
            <button
              type="button"
              key={tab}
              onClick={() => setActiveTab(idx)}
              className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                activeTab === idx
                  ? "bg-primary-600 text-background-50 font-medium"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-1">
        {rankings.map((item) => (
          <a
            href="#videos"
            key={item.rank}
            className="group flex items-center gap-4 py-3.5 border-b border-background-200/70 cursor-pointer"
          >
            <span
              className={`w-8 h-8 shrink-0 rounded-md flex items-center justify-center font-heading font-black text-sm ${
                item.rank <= 3
                  ? "bg-primary-600 text-background-50"
                  : "bg-background-200 text-foreground-700"
              }`}
            >
              {item.rank}
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate group-hover:text-primary-600">
                {item.title}
              </h3>
              <span className="mt-0.5 inline-block text-xs text-foreground-500">{item.tag}</span>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <span className="font-heading font-bold text-accent-700 text-sm md:text-base">{item.hot}</span>
              <span className="w-5 h-5 flex items-center justify-center">{trendIcon(item.trend)}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}